import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';
import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';
import { ChartType } from '@legacy-modules/metrics2/models/enumerations/ChartType';

export default new ValueExpression({
  identifier: 'lademenge_ist',
  positiveDirection: PositiveDirection.custom,
  label: 'IST-Lademenge',
  definition: getDefinitionByName('IST-Lademenge'),
  chart: ChartType.bar,
});
